import React, { useRef } from "react";
import { Link } from "react-router-dom";
import CourseCard from "./CourseCard";
import { cheapestPackageFor, priceFor } from "./learnApi";

/**
 * Horizontal shelf of cards with a serif row title, optional "See all" link
 * and prev/next arrows on desktop. Scroll-snaps on touch devices.
 * `disabled` (coming-soon mode) makes every card inert; `packages` lets
 * locked cards show a "from $X" price.
 */
const CourseRow = ({ title, subtitle, courses = [], seeAllTo, id, disabled = false, packages = [], isAttendee = false }) => {
  const trackRef = useRef(null);
  if (!courses.length) return null;

  const scrollBy = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    const card = el.querySelector(".learn-card");
    const step = card ? card.getBoundingClientRect().width + 24 : el.clientWidth * 0.8;
    el.scrollBy({ left: dir * step * 2, behavior: "smooth" });
  };

  return (
    <section className="learn-row" id={id}>
      <header className="learn-row__head">
        <div>
          <h2 className="learn-row__title">{title}</h2>
          {subtitle && <p className="learn-row__subtitle">{subtitle}</p>}
        </div>
        <div className="learn-row__actions">
          {seeAllTo && !disabled && <Link to={seeAllTo} className="learn-row__seeall">See all</Link>}
          <button type="button" className="learn-row__arrow" aria-label="Scroll back" onClick={() => scrollBy(-1)}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </button>
          <button type="button" className="learn-row__arrow" aria-label="Scroll forward" onClick={() => scrollBy(1)}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 3l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </button>
        </div>
      </header>
      <div className="learn-row__track" ref={trackRef}>
        {courses.map((c) => (
          <CourseCard
            key={c.id}
            course={c}
            className="learn-row__card"
            disabled={disabled}
            priceFrom={c.locked ? priceFor(cheapestPackageFor(c, packages, isAttendee), isAttendee) : null}
          />
        ))}
      </div>
    </section>
  );
};

export default CourseRow;
